import getRoleProperty from '../getRoleProperty';

class ContactRoleDriverCtrl {
    constructor($filter) {
        this._translator = name => $filter('translate')(`gateway.contacts.components.ContactDetails.Roles.Driver.${name}`);
    }

    $onInit() {
        const {fieldValueGetter} = getRoleProperty(this.roleType, this.roleModel, 'driver', 'policyDriver');

        const accidents = fieldValueGetter('accidents', 'policyLevelNumberOfAccidents');
        if (accidents) this.accidents = accidents.name;


        const violations = fieldValueGetter('violations', 'policyLevelNumberOfViolations');
        if (violations) this.violations = violations.name;

        if (this.roleType === 'account') {
            this.accidentsLabel = this._translator('Account.Accidents');
            this.violationsLabel = this._translator('Account.Violations');
        } else {
            this.accidentsLabel = this._translator('Policy.Accidents');
            this.violationsLabel = this._translator('Policy.Violations');
        }

        this.yearLicensed = fieldValueGetter('yearLicensed');
        this.licenseNumber = fieldValueGetter(undefined, 'licenseNumber');

        const licenseState = fieldValueGetter(undefined, 'licenseState');
        if (licenseState) this.licenseState = licenseState.name;

        this.dateCompletedTrainingClass = fieldValueGetter('dateCompletedTrainingClass');

        const trainingClassType = fieldValueGetter('trainingClassType');
        if (trainingClassType) this.trainingClassType = trainingClassType.name;

        const yes = this._translator('Yes');
        const no = this._translator('No');

        const goodStudent = fieldValueGetter('goodStudent');
        if (goodStudent !== undefined) this.goodStudent = goodStudent ? yes : no;

        const qualifiesForGoodDriverDiscount = fieldValueGetter('goodDriverDiscount');
        if (qualifiesForGoodDriverDiscount !== undefined) {
            this.qualifiesForGoodDriverDiscount = qualifiesForGoodDriverDiscount ? yes : no;
        }
        const applyGoodDriverDiscount = fieldValueGetter(undefined, 'applicableGoodDriverDiscount');
        if (applyGoodDriverDiscount !== undefined) {
            this.applyGoodDriverDiscount = applyGoodDriverDiscount ? yes : no;
        }

        const excluded = fieldValueGetter(undefined, 'excluded');
        if (excluded !== undefined) this.excluded = excluded ? yes : no;
    }
}
ContactRoleDriverCtrl.$inject = ['$filter'];
export default ContactRoleDriverCtrl;
